import React from 'react'
import Lottie from 'lottie-react'
import animationData from '../../assets/animation/About.json'
import "./AboutUs.scss"

function AboutUs() {
	return (
		<div className='aboutUs' id='about'>
			{/* Lottie Background */}
			<div className='lottieAboutus'>
				<Lottie
					animationData={animationData}
					loop
					autoPlay
					className="aboutUs-lottie"
				/>
			</div>

			{/* Content */}
			<div className='aboutUs-content'>
				<h4>About UniWallet Pay</h4>
				<h2>A Force of Financial <br /> Evolution</h2>
				<p>
					We are on a mission to humanize financial systems and create a future where capital moves with unprecedented dynamism,
					adapting seamlessly to your needs. With our deep expertise in fintech, blockchain, and compliance, we have made a
					platform that integrates fiat and crypto into one cohesive, intelligent network.
				</p>
			</div>
		</div>
	)
}

export default AboutUs
